export const GRAPHEME_DESCRIPTION_SUPERWALL_PLACEMENT = "grapheme_description";
export const SETTINGS_PREMIUM_SUPERWALL_PLACEMENT = "settings_upgrade_to_premium";
/** Adding a grapheme past the free tier's level boundary — see `useFreeTierGate`. */
export const LEARN_BEYOND_FREE_TIER_SUPERWALL_PLACEMENT = "learn_beyond_free_tier";
